import React from "react";
import { useAuth } from "../../Auth/AuthProvider";
import { useUserRequests } from "../../hooks/useUserRequests";
import { Routes, Route, Navigate } from "react-router-dom";
import NavLink from "../../Components/NavLink";
import { dashboard } from "../../routes";
import RequestItem from "./Components/RequestItem/RequestItem";

export default function Dashboard() {
  const { uid } = useAuth();
  const { routes, basePath } = dashboard;
  const requests = useUserRequests(uid);

  const filterRequests = (status) => {
    if (!requests) {
      return [];
    }

    return requests
      .filter((request) => request && request.status === status)
      .map((request) => <RequestItem key={request.request_id} {...request} />);
  };

  return (
    <>
      <div className="mb-8 mt-6 flex flex-wrap gap-2">
        {Object.keys(routes).map((routeKey) => {
          const count = filterRequests(routes[routeKey].dataStatusCode).length;
          const disabled = count === 0 && routes[routeKey].path !== "requests";

          return (
            <NavLink
              key={routeKey}
              to={basePath + routes[routeKey].path}
              className={`inline-flex items-center gap-2 rounded-full px-3 py-2 text-sm transition ${
                disabled
                  ? "pointer-events-none bg-mauve-100 text-mauve-300"
                  : "bg-mauve-100 text-mauve-700 hover:bg-mauve-200"
              }`}
              activeClassName="!bg-mauve-800 !text-white"
            >
              {({ isActive }) => (
                <>
                  {routes[routeKey].name}
                  {count > 0 ? (
                    <span
                      className={`rounded-full bg-mauve-500/20 px-2 py-0.5 text-xs ${isActive ? "!bg-mauve-50 text-mauve-800" : ""}`}
                    >
                      {count}
                    </span>
                  ) : null}
                </>
              )}
            </NavLink>
          );
        })}
      </div>

      <Routes>
        {Object.keys(routes).map((routeKey) => {
          const RouteComponent = routes[routeKey].component;
          return (
            <Route
              path={routes[routeKey].path}
              key={routeKey}
              element={
                <RouteComponent
                  requests={filterRequests(routes[routeKey].dataStatusCode)}
                  dataStatusCode={routes[routeKey].dataStatusCode}
                />
              }
            />
          );
        })}

        <Route path="*" element={<Navigate to="requests" replace />} />
      </Routes>
    </>
  );
}
